import { MovieOpenStarOutlineIcon } from './MovieOpenStarOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 85F303FB-9847-450E-BF4B-7A38C86386AF
 * name movie-open-star-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-star-outline.svg
 * tags
 * - Video / Movie 
 */
export const MovieOpenFavoriteOutlineIcon = MovieOpenStarOutlineIcon;
export default MovieOpenFavoriteOutlineIcon